/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestDeleteNoticeRequest
 */
export interface RequestDeleteNoticeRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteNoticeRequest
     */
    baseId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestDeleteNoticeRequest
     */
    ids: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteNoticeRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteNoticeRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestDeleteNoticeRequest interface.
 */
export function instanceOfRequestDeleteNoticeRequest(value: object): value is RequestDeleteNoticeRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestDeleteNoticeRequestFromJSON(json: any): RequestDeleteNoticeRequest {
    return RequestDeleteNoticeRequestFromJSONTyped(json, false);
}

export function RequestDeleteNoticeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeleteNoticeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'ids': json['ids'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestDeleteNoticeRequestToJSON(json: any): RequestDeleteNoticeRequest {
    return RequestDeleteNoticeRequestToJSONTyped(json, false);
}

export function RequestDeleteNoticeRequestToJSONTyped(value?: RequestDeleteNoticeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'ids': value['ids'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

